var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end"},[_c('b-button',{staticClass:"rounded",attrs:{"variant":"primary","type":"submit","disabled":_vm.loading}},[(_vm.loading)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),_c('span',{staticClass:"mx-2"},[_vm._v(_vm._s(_vm.label))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }